import React from 'react';
var LogoMarkSpecsSVG = function LogoMarkSpecsSVG(_ref) {
    var width = _ref.width, svgClassName = _ref.svgClassName, fillClassName = _ref.fillClassName, strokeClassName = _ref.strokeClassName, dashClassName = _ref.dashClassName;
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 910 640",
        width: width,
        className: svgClassName
    }, /*#__PURE__*/ React.createElement("path", {
        className: fillClassName,
        d: "M614.57,322.96c37.44-10.9,75.89-41.2,90.86-74.68c16.19-36.22,15.49-83.79,14.78-101.54 c-0.7-17.75-2.82-47.58-3.52-57.52c-0.7-9.94-2.28-21.6-9.5-26.89c-4.14-3.03-16.01-9.23-104.04,20.76 c-70.45,23.99-91.41,76.44-96.87,97.54c-2.6,10.03-2.6,28.67-2.6,33.49v105.82c0,0.13,0.02,0.26,0.02,0.39 c0,0.13-0.02,0.26-0.02,0.39v114.53c0,9.13,1.1,22.67,3.81,33.93c5.74,21.02,25.21,69.68,95.66,93.67 c88.03,29.98,99.9,23.79,104.04,20.76c7.23-5.29,8.8-16.95,9.5-26.89s2.82-39.77,3.52-57.52c0.7-17.75,1.41-65.33-14.78-101.54 C690.45,364.16,652,333.86,614.57,322.96z M306.85,83.08c-88.03-29.98-99.9-23.79-104.04-20.76c-7.23,5.29-8.8,16.95-9.5,26.89 c-0.7,9.94-2.82,39.77-3.52,57.52c-0.7,17.75-1.41,65.33,14.78,101.54c14.97,33.49,53.42,63.79,90.86,74.68 c-37.44,10.9-75.89,41.19-90.86,74.68c-16.19,36.22-15.49,83.79-14.78,101.54c0.7,17.75,2.82,47.58,3.52,57.52 c0.7,9.94,2.28,21.6,9.5,26.89c4.14,3.03,16.01,9.23,104.04-20.76c70.45-23.99,89.92-72.65,95.66-93.67 c2.71-11.26,3.81-24.8,3.81-33.93V320.71c0-0.13-0.02-0.26-0.02-0.39c0-0.13,0.02-0.26,0.02-0.39V214.1c0-4.82,0-23.46-2.6-33.49 C398.26,159.52,377.3,107.07,306.85,83.08z"
    }), /*#__PURE__*/ React.createElement("g", {
        className: dashClassName
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: "261.5",
        cy: "229.5",
        r: "153",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "261.5",
        cy: "418.5",
        r: "153",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "648.5",
        cy: "229.5",
        r: "153",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "648.5",
        cy: "418.5",
        r: "153",
        vectorEffect: "non-scaling-stroke"
    })), /*#__PURE__*/ React.createElement("g", {
        className: strokeClassName
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: "333.5",
        cy: "175.5",
        r: "153",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "333.5",
        cy: "472.5",
        r: "153",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "576.5",
        cy: "175.5",
        r: "153",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "576.5",
        cy: "472.5",
        r: "153",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "405.5",
        y1: "13.5",
        x2: "405.5",
        y2: "625.5",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "504.5",
        y1: "13.5",
        x2: "504.5",
        y2: "625.5",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "720.5",
        y1: "13.5",
        x2: "720.5",
        y2: "625.5",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "189.5",
        y1: "13.5",
        x2: "189.5",
        y2: "625.5",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "774.5",
        y1: "31.5",
        x2: "9.5",
        y2: "265.5",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "135.5",
        y1: "31.5",
        x2: "900.5",
        y2: "265.5",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "774.5",
        y1: "616.5",
        x2: "9.5",
        y2: "382.5",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "135.5",
        y1: "616.5",
        x2: "900.5",
        y2: "382.5",
        vectorEffect: "non-scaling-stroke"
    })));
};
export default LogoMarkSpecsSVG;
